// extracted by mini-css-extract-plugin
export default {"root":"Search_root__fPm0e"};